import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

import { detectAndBestEffortSetLanguage } from '../../../../../utils/localisationUtils';

const DynamicPage = dynamic(
  () => import('../../../../../components/dynamicPages/GamePage'),
  { ssr: true, loading: () => <div>{/* TODO add fancy loader */}</div> },
);

const LivePage = () => <DynamicPage />;
export const getServerSideProps: GetServerSideProps = async context => {
  return {
    props: {
      ...(await detectAndBestEffortSetLanguage(context)),
    },
  };
};
export default LivePage;
